import React, { useState } from "react";
import "./ProgramTagsSection.css";

const activityLevelOptions = ["Beginner", "Intermediate", "Advanced"];
const ageRangeOptions = ["15-25", "26-35", "36-45", "46-55", "56-60", "61-65", "66-70", "71-75", "76-80", "81-100"];
const genderOptions = ["Male", "Female"];
const bmiRangeOptions = ["<18.5", "18.5-24.9", "25-29.9", "30+"];
const bmrRangeOptions = ["<1200", "1200-1500", "1500-1800", "1800+"];
const dcrRangeOptions = ["<1800", "1800-2200", "2200-2600", "2600+"];
const fitnessGoalOptions = [
        "Weight Loss",
        "Weight Gain",
        "Muscle Gain",
        "Strength",
        "Endurance",
        "Flexibility",
        "General Health",
        "Fat Loss",
        "Toning",
        "Athletic Performance",
        "Recovery",
        "Rehabilitation",
        "Cardiovascular Health",
        "Mobility",
        "Stress Reduction",
        "Healthy Aging"];

const ProgramTagsSection = ({
  activityLevels, setActivityLevels,
  ageRanges, setAgeRanges,
  genders, setGenders,
  bmiRanges, setBmiRanges,
  bmrRanges, setBmrRanges,
  dcrRanges, setDcrRanges,
  fitnessGoals, setFitnessGoals
}) => {
  const handleMultiSelect = (setter, value, selected) => {
    setter(selected.includes(value)
      ? selected.filter((v) => v !== value)
      : [...selected, value]);
  };

  return (
    <div className="program-tags-section">
      <label className="section-title">Add tags to make this program discoverable for users</label>
      <div className="tags-columns">
        <div className="tag-column">
          <div className="tag-group">
            <label style={{fontWeight: 'bold'}}>Activity Level</label>
            <div className="tag-options">
              {activityLevelOptions.map((level) => (
                <label key={level} className="tag-label">
                  <input
                    type="checkbox"
                    checked={activityLevels.includes(level)}
                    onChange={() => handleMultiSelect(setActivityLevels, level, activityLevels)}
                  /> {level}
                </label>
              ))}
            </div>
          </div>
          <div className="tag-group">
            <label style={{fontWeight: 'bold'}}>Gender</label>
            <div className="tag-options">
              {genderOptions.map((gender) => (
                <label key={gender} className="tag-label">
                  <input
                    type="checkbox"
                    checked={genders.includes(gender)}
                    onChange={() => handleMultiSelect(setGenders, gender, genders)}
                  /> {gender}
                </label>
              ))}
            </div>
          </div>
          <div className="tag-group">
            <label style={{fontWeight: 'bold'}}>Fitness Goals</label>
            <div className="tag-options">
              {fitnessGoalOptions.map((goal) => (
                <label key={goal} className="tag-label">
                  <input
                    type="checkbox"
                    checked={fitnessGoals.includes(goal)}
                    onChange={() => handleMultiSelect(setFitnessGoals, goal, fitnessGoals)}
                  /> {goal}
                </label>
              ))}
            </div>
          </div>
        </div>
        <div className="tag-column">
          <div className="tag-group">
            <label style={{fontWeight: 'bold'}}>Age Range</label>
            <div className="tag-options">
              {ageRangeOptions.map((range) => (
                <label key={range} className="tag-label">
                  <input
                    type="checkbox"
                    checked={ageRanges.includes(range)}
                    onChange={() => handleMultiSelect(setAgeRanges, range, ageRanges)}
                  /> {range}
                </label>
              ))}
            </div>
          </div>
          <div className="tag-group">
            <label style={{fontWeight: 'bold'}}>BMI Range</label>
            <div className="tag-options">
              {bmiRangeOptions.map((range) => (
                <label key={range} className="tag-label">
                  <input
                    type="radio"
                    name="bmiRange"
                    checked={bmiRanges[0] === range}
                    onChange={() => setBmiRanges([range])}
                  /> {range}
                </label>
              ))}
            </div>
          </div>
          <div className="tag-group">
            <label style={{fontWeight: 'bold'}}>BMR Range</label>
            <div className="tag-options">
              {bmrRangeOptions.map((range) => (
                <label key={range} className="tag-label">
                  <input
                    type="radio"
                    name="bmrRange"
                    checked={bmrRanges[0] === range}
                    onChange={() => setBmrRanges([range])}
                  /> {range}
                </label>
              ))}
            </div>
          </div>
          <div className="tag-group">
            <label style={{fontWeight: 'bold'}}>DCR Range</label>
            <div className="tag-options">
              {dcrRangeOptions.map((range) => (
                <label key={range} className="tag-label">
                  <input
                    type="radio"
                    name="dcrRange"
                    checked={dcrRanges[0] === range}
                    onChange={() => setDcrRanges([range])}
                  /> {range}
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>
      <hr className="divider" />
    </div>
  );
};

export default ProgramTagsSection;
